import { render, staticRenderFns } from "./AddReceiving.vue?vue&type=template&id=267064e8"
import script from "./AddReceiving.vue?vue&type=script&lang=js"
export * from "./AddReceiving.vue?vue&type=script&lang=js"
import style0 from "./AddReceiving.vue?vue&type=style&index=0&id=267064e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports